export default __webpack_public_path__ + "static/media/icon_arrow-down.1d90ba62.svg";